import { createVanIconComponent } from "./van"

const PeerPay = createVanIconComponent("peer-pay")
export default PeerPay
